module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "EXTFF"
  }, [_vm._v("“So for a day and a night and yet another day Edward Duke of Clarence lingered at the portal of death. It is fruitless to speculate on how our nation might have developed had Eddy crossed the dark threshold. In due time, no doubt, his brother the Duke of York would have inherited the throne and reigned (presumably) as King George V, to be succeeded in turn by  … by whom? The glass of imaginary history reflects nothing but vague mists. Perhaps by now the world would have known a Republic of Great Britain. Perhaps George, bluff and sailorly, would have steered a course towards a more active, less amenable monarchy. Or perhaps all would have been very much as we know it today, with only the head on our stamps and coins different.")]), _vm._v(" "), _c('p', {
    staticClass: "EXTM"
  }, [_vm._v("Fruitless indeed to speculate. For, to the relief of the Royal Family and the well-concealed amazement of the Royal doctors, the future King Victor I withdrew with painful slowness from that shadowed threshold and returned to the living world and, to the arms of his betrothed, Princess Mary of Teck. She saw to it that he never knew another day’s illness.”")]), _vm._v(" "), _c('p', {
    staticClass: "EXTF"
  }, [_vm._v("(from "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("King Victor I")]), _vm._v(", an unpublished fragment by Lytton Strachey)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8b41d62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/Dickinson_KingandJoker_2P_MD-3.vue
// module id = 81
// module chunks = 0